import { styled } from '@mui/material';

import { BellIcon } from '@app-velocity/icons';
import { MessageBus } from '@app-velocity/message-bus';

import { useNotifications } from '../../hooks';

const IndicatorContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  cursor: 'pointer',
  padding: theme.spacing(1),
  svg: {
    fill: 'var(--icon-icon-secondary-color)',
  },
  '&:hover': {
    svg: {
      fill: 'var(--text-text-color-primary)',
    },
  },
}));

const Badge = styled('div')(({ theme }) => ({
  background: 'var(--error-error-color)',
  width: theme.spacing(1.75),
  height: theme.spacing(1.75),
  position: 'absolute',
  borderRadius: '50%',
  right: theme.spacing(0.25),
  top: theme.spacing(0.25),
}));

const messageBus = new MessageBus('users');

export const NotificationsIndicator = () => {
  const { count } = useNotifications();

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    messageBus.publish('modal:notifications:open');
  };

  return (
    <IndicatorContainer onClick={handleClick}>
      <BellIcon />
      {count > 0 ? <Badge /> : null}
    </IndicatorContainer>
  );
};
